/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для накладных расходов проекта (CRUD).
 * SCOPE: HTTP-вызовы /api/projects/{id}/overheads.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-PROJECT-OVERHEAD
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getProjectOverheads - список накладных расходов.
 * createProjectOverhead - создать запись.
 * updateProjectOverhead - обновить запись.
 * deleteProjectOverhead - удалить запись.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getProjectOverheads */
/* START_CONTRACT: getProjectOverheads
 * PURPOSE: Получить список накладных расходов проекта.
 * INPUTS: { projectId: number|string, signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET overheads }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-OVERHEAD
 * END_CONTRACT: getProjectOverheads
 */
export function getProjectOverheads(projectId, signal) {
  return apiClient.get(`/api/projects/${projectId}/overheads`, { signal });
}
/* END_METHOD_getProjectOverheads */

/* START_METHOD_createProjectOverhead */
/* START_CONTRACT: createProjectOverhead
 * PURPOSE: Создать накладной расход.
 * INPUTS: { projectId: number|string, payload: object }
 * OUTPUTS: { Promise<AxiosResponse> - POST overhead }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-OVERHEAD
 * END_CONTRACT: createProjectOverhead
 */
export function createProjectOverhead(projectId, payload) {
  return apiClient.post(`/api/projects/${projectId}/overheads`, payload);
}
/* END_METHOD_createProjectOverhead */

/* START_METHOD_updateProjectOverhead */
/* START_CONTRACT: updateProjectOverhead
 * PURPOSE: Обновить накладной расход.
 * INPUTS: { projectId, overheadId, payload: object }
 * OUTPUTS: { Promise<AxiosResponse> - PUT overhead }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-OVERHEAD
 * END_CONTRACT: updateProjectOverhead
 */
export function updateProjectOverhead(projectId, overheadId, payload) {
  return apiClient.put(`/api/projects/${projectId}/overheads/${overheadId}`, payload);
}
/* END_METHOD_updateProjectOverhead */

/* START_METHOD_deleteProjectOverhead */
/* START_CONTRACT: deleteProjectOverhead
 * PURPOSE: Удалить накладной расход.
 * INPUTS: { projectId, overheadId }
 * OUTPUTS: { Promise<AxiosResponse> - DELETE overhead }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-OVERHEAD
 * END_CONTRACT: deleteProjectOverhead
 */
export function deleteProjectOverhead(projectId, overheadId) {
  return apiClient.delete(`/api/projects/${projectId}/overheads/${overheadId}`);
}
/* END_METHOD_deleteProjectOverhead */
